import { render, staticRenderFns } from "./ReportCheckListSoStands.vue?vue&type=template&id=057e51ab&scoped=true&"
import script from "./ReportCheckListSoStands.vue?vue&type=script&lang=js&"
export * from "./ReportCheckListSoStands.vue?vue&type=script&lang=js&"
import style0 from "./ReportCheckListSoStands.vue?vue&type=style&index=0&id=057e51ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057e51ab",
  null
  
)

export default component.exports
import {QBtn,QItem,QInput,QField,QRadio} from 'quasar'
component.options.components = Object.assign({QBtn,QItem,QInput,QField,QRadio}, component.options.components || {})
